import { Libraries } from "@react-google-maps/api";

export const calculateCenter = (coordinates: any) => {
  const center = coordinates.reduce(
    (accumulator: { lat: any; lng: any }, point: { lat: any; lng: any }) => {
      accumulator.lat += point.lat;
      accumulator.lng += point.lng;
      return accumulator;
    },
    { lat: 0, lng: 0 }
  );

  center.lat /= coordinates.length;
  center.lng /= coordinates.length;

  return center;
};

export const MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API;

export const AGRO_API_KEY = process.env.REACT_APP_AGRO_API_KEY

export const REACT_MAP_LIBRARIE: Libraries = ["drawing", "visualization"];


export function getColorForValue(value: number): string {
  if (value >= 0 && value < 0.1) return "#F94144";
  if (value >= 0.1 && value < 0.2) return "#F3722C";
  if (value >= 0.2 && value < 0.3) return "#F8961E";
  if (value >= 0.3 && value < 0.4) return "#F9844A";
  if (value >= 0.4 && value < 0.5) return "#F9C74F";
  if (value >= 0.5 && value < 0.6) return "#90BE6D";
  if (value >= 0.6 && value < 0.7) return "#43AA8B";
  if (value >= 0.7 && value < 0.8) return "#4D908E";
  if (value >= 0.8 && value < 0.9) return "#557590";
  if (value >= 0.9 && value <= 1) return "#277DA1";

  return "#000000";
}

export const formatDate = (dateInput: Date | string) => {
  const date = new Date(dateInput);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return 'Today';
  }

  if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  }

  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}

export const displayUserRole = (role: number) => {
  switch (role) {
    case 1:
      return 'Admin';
    case 2:
      return 'Editor';
    default:
      return 'Viewer';
  }
}

export function convertTempKelvinToCelsius(kelvin: number): number {
  let degTemp = kelvin - 273.15;
  return Number(degTemp.toFixed(2))
}